$(document).ready(function() {
    // making notes empty to re-assign the value
   
      var urlParams = new URLSearchParams(window.location.search);
      // searching for affiliate query param
      if (urlParams.has('affid')) { 
        
        // setting it to localstorage so that variable can be accessible from every page
              localStorage.removeItem("affid");
              localStorage.setItem("affid", urlParams.get('affid'));
              addNote(urlParams.get('affid'));
      }
      if ( localStorage.getItem("affid") ) {
         // Accessing affiliate param from local storage to pass it through notes
             //console.log('test2',localStorage.getItem("affid"));
             addNote(localStorage.getItem('affid'));
      }
});
  
function addNote(notes=''){
    
    $.ajax({
                url: '/cart/update.js',
                type: 'POST',
                data: {note: 'AffliateID:' + notes},
                success: function(result) { 
                  console.log('Result ',result);
                }
    });
}